import { ChangeEvent, forwardRef, useCallback, useMemo } from "react";

const SafeInput = forwardRef<
  HTMLInputElement,
  {
    value: string;
    onChange: (value: string) => void;
    regex: RegExp;
    id: string;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    prefix?: string;
    dataTestId?: string;
  }
>(
  (
    {
      value,
      onChange,
      id,
      placeholder,
      regex,
      className,
      disabled,
      prefix,
      dataTestId,
    },
    ref,
  ) => {
    const size = useMemo(() => Math.max(1, value.length), [value]);

    const handleChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        const newInputValue = e.target.value;
        if (newInputValue === ".") {
          return;
        }
        if (newInputValue === prefix) {
          onChange("");
          return;
        }
        if (newInputValue.length === 1) {
          if (regex.test(newInputValue)) {
            onChange(newInputValue.replace(/,/g, "."));
          }
        } else if (regex.test(newInputValue.slice(prefix?.length || 0))) {
          onChange(newInputValue.slice(prefix?.length || 0).replace(/,/g, "."));
        }
      },
      [onChange, regex, prefix],
    );

    return (
      <input
        ref={ref}
        id={id}
        type="text"
        size={size}
        placeholder={placeholder || "0"}
        pattern={regex.toString()}
        inputMode="decimal"
        spellCheck="false"
        autoComplete="off"
        autoCorrect="off"
        disabled={disabled}
        value={`${value.length > 0 ? (prefix || "") + value : ""}`}
        onChange={handleChange}
        className={className}
        // NOTE: used in e2e tests — do not remove
        data-testid={dataTestId}
      />
    );
  },
);

SafeInput.displayName = "SafeInput";
export { SafeInput };
